// extracted by mini-css-extract-plugin
export var cardHeader = "_ho-0";
export var reorderHandle = "_ho-3";
export var titleArea = "_ho-1";
export var titleAreaWithHandle = "_ho-2";